export default "__VITE_ASSET__394c3fae__"